import { useRef } from "react";
import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";

export const useTrackAudioPlayStart = (play: () => void): (() => void) => {
  const hasStarted = useRef(false);

  return () => {
    if (!hasStarted.current) {
      hasStarted.current = true;
      trackEvents(EventNames.AUDIO_START);
    }
    play();
  };
};
